import { render, staticRenderFns } from "./Colmenar.vue?vue&type=template&id=af3a8c98&scoped=true&"
import script from "./Colmenar.vue?vue&type=script&lang=js&"
export * from "./Colmenar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3a8c98",
  null
  
)

export default component.exports